import { useTranslation } from 'react-i18next';
import { formatIntNumber } from '@anytag/shared-utils';
import { RangeSliderInputField } from '@anytag/shared-molecules';
import { MIN_MAX_VIEW_OPTIONS, MIN_VIEWS, MAX_VIEWS } from '@anytag/shared-constants';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const ViewField = () => {
  const { t } = useTranslation();

  return (
    <RangeSliderInputField<InfluencersFilterFormKeys>
      title={t('Avg View')}
      options={MIN_MAX_VIEW_OPTIONS}
      slideProps={{ step: 10000, min: MIN_VIEWS, max: MAX_VIEWS }}
      minField={{ placeholder: formatIntNumber(MIN_VIEWS), name: 'minViews' }}
      maxField={{ placeholder: `${formatIntNumber(MAX_VIEWS)}+`, name: 'maxViews' }}
    />
  );
};
